import React, { ReactElement } from 'react'

import { ButtonClick, track } from '@dfds-frontend/tracking'

import Dialog from '@/app/[locale]/[ferry]/Dialog'

import { useTranslation } from '@/hooks/useDebugTranslations'

const onButtonClick = (canContinue: boolean, onContinue: (canContinue: boolean) => void) => {
  track<ButtonClick>({
    clickedElementText: '',
    event: 'buttonClick',
    eventAction: `onewayRemoveReturnDeparture${canContinue ? 'Continue' : 'Cancel'}`,
  })
  onContinue(canContinue)
}

interface Props {
  onContinue: (canContinue: boolean) => void
  show: boolean
}

const OnewayModal: React.FC<Props> = ({ onContinue, show }: Props): ReactElement => {
  const { t } = useTranslation()

  return (
    <Dialog
      dataAttr="oneway-departure"
      description={t('ONEWAY-MODAL-DESCRIPTION')}
      headline={t('ONEWAY-MODAL-HEADER')}
      onPrimaryButtonClicked={() => onButtonClick(true, onContinue)}
      onRequestClose={() => onButtonClick(false, onContinue)}
      onSecondaryButtonClicked={() => onButtonClick(false, onContinue)}
      primaryButtonText={t('ONEWAY-MODAL-BUTTON-CONTINUE')}
      secondaryButtonText={t('ONEWAY-MODAL-BUTTON-CANCEL')}
      show={show}
    />
  )
}

export default OnewayModal
